import {rootStore} from '@/features/core/store/store';
import {setTheme} from './setTheme';

function initTheme() {
  const theme = rootStore.getState().settings.theme.name;
  setTheme(theme);

  rootStore.subscribe((state) => {
    const theme = state.settings.theme.name;
    setTheme(theme);
  });
}

export {initTheme};
